/**
 * @generated SignedSource<<ad3860cab9abbe114b923c268af9689e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type RoutineIcon = "key" | "residual" | "shelf_hole" | "waste";
import { FragmentRefs } from "relay-runtime";
export type KPIAdminListItem_Routine$data = {
  readonly activeSections: ReadonlyArray<{
    readonly assignedTeam: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"KPITeamIcon_Team">;
    } | null;
    readonly id: string;
  }>;
  readonly icon: RoutineIcon | null;
  readonly id: string;
  readonly schedule: {
    readonly rules: ReadonlyArray<{
      readonly byweekday: ReadonlyArray<number | null> | null;
    }>;
  } | null;
  readonly title: string;
  readonly " $fragmentType": "KPIAdminListItem_Routine";
};
export type KPIAdminListItem_Routine$key = {
  readonly " $data"?: KPIAdminListItem_Routine$data;
  readonly " $fragmentSpreads": FragmentRefs<"KPIAdminListItem_Routine">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "KPIAdminListItem_Routine",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "icon",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Schedule",
      "kind": "LinkedField",
      "name": "schedule",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RecurrenceRule",
          "kind": "LinkedField",
          "name": "rules",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "byweekday",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RoutineSection",
      "kind": "LinkedField",
      "name": "activeSections",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Team",
          "kind": "LinkedField",
          "name": "assignedTeam",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "KPITeamIcon_Team"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Routine",
  "abstractKey": null
};
})();

(node as any).hash = "7e60cecbd0ef6da6e36b2c2a57b4a4fc";

export default node;
